import React, { FC } from "react";
import { Grid, Typography } from "@material-ui/core";
import { singleCardsStyles } from "../../style/singleCardsStyles";
import { InfoIconOnClick } from "../popover/InfoIconOnClick";
import { DecidiTuDescription } from "./info/DecidiTuDescription";

export const DecidiTu: FC = () => {
  const classes = singleCardsStyles();
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant={"h2"}>
          Decidi Tu!
          <InfoIconOnClick description={<DecidiTuDescription />} />
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant={"body2"} className={classes.boxText}>
          In caso di sinistro potrai scegliere di incaricare:
        </Typography>
        <Typography variant={"body2"} className={classes.boxText}>
          • il tuo avvocato, con l’applicazione di uno scoperto del 20% sulle spese legali per la fase giudiziale. Lo
          scoperto sarà minimo €750 e massimo di €2.500
        </Typography>
        <Typography variant={"body2"} className={classes.boxText}>
          oppure
        </Typography>
        <Typography variant={"body2"} className={classes.boxText}>
          • l’avvocato proposto da ARAG, senza l’applicazione dello scoperto e con un massimale aumentato del 50%.
        </Typography>
      </Grid>
    </Grid>
  );
};
